import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ds-radio-button",
  templateUrl: "./ds-radio-button.component.html",
  styleUrls: ["./ds-radio-button.component.scss"],
})
export class DsRadioButtonComponent {
  @Input() label: string;
  @Input() value!: string;
  @Input() name!: string;
  @Input() disabled: boolean = false;
  @Input() checked: boolean = false;
  @Input() valueChecked: string = "";
  @Input() error: boolean = false;
  @Input() errorMessage: string = "";
  @Output() selectionChange = new EventEmitter<string>();

  constructor() {}

  onSelectionChange() {
    this.selectionChange.emit(this.value);
  }
}
